module.exports = __webpack_public_path__ + "media/images/lilica/lilica-80562adb205ba4d605625bf77b5c8940.png";